// removed by extract-text-webpack-plugin
module.exports = {"background-purple":"#eff0f4","orange":"#ef8d07","top-banner-height":"225px","app-grey":"#f5f6fa","modalWrapper":"_1Irj5ElexRQy81RK1a5sLQ","modalWithGrid":"yuSPMZM5UpdkS2NxTA00I","closeButton":"_25FgcOXpeHK4N79M1pWSWu","transitionEnter":"K3nAxVNUwADByTkcqeShB","transitionEnterActive":"_1Su6znvPm3DJjPjWivhGsx","transitionExit":"_14h4NIERN6n5uOuYJeftgT","transitionExitActive":"_1_LjFKBRujhi8GLPjBolFk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.css
// module id = 812
// module chunks = 0